export default {
  'account-details-title': 'Nesten ferdig',
  'address-lookup-enter-manually': 'Skriv inn adresse manuelt',
  'address-lookup-label': 'Begynn å skrive og velg adresse fra listen',
  'country-please-select': 'Velg',
  'create-account-success-body-text-activated': 'Vi er glade for å ha deg med!',
  'create-account-success-heading-activated': 'Gratulerer',
  'gender-please-select': 'Velg',
  'password-help-text': 'Bruk minst 8 tegn',
  'sign-up': 'Registrer deg',
  'terms-and-conditions-privacy-policy-and-funds-policy':
    'Jeg bekrefter at jeg er 18 år eller eldre og at jeg aksepterer <a href="/?page=terms" target="_blank" class="ui-link">vilkår og betingelser</a>, <a href="/?page=privacy" target="_blank" class="ui-link">personvern- og cookie-erklæring</a> samt <a href="/?page=terms#funds-policy" target="_blank" class="ui-link">retningslinjer for midler</a>.',
  'username-help-text': 'Bruk 6-20 bokstaver og tall, små bokstaver uten mellomrom.',
  continue: 'Fortsett',
  dd: 'DD',
  email: 'E-post',
  mm: 'MM',
  yyyy: 'ÅÅÅÅ',
};
